import { render, staticRenderFns } from "./FamilyFormularManual.vue?vue&type=template&id=338ae46b&scoped=true"
import script from "./FamilyFormularManual.vue?vue&type=script&lang=js"
export * from "./FamilyFormularManual.vue?vue&type=script&lang=js"
import style0 from "./FamilyFormularManual.vue?vue&type=style&index=0&id=338ae46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ae46b",
  null
  
)

export default component.exports